import Glide from '@glidejs/glide';

class glideLoader {
    constructor() {
        this.initSettings();
        this.setupGliders();
    }

    initSettings() {
    }

    setupGliders() {
        document.addEventListener('DOMContentLoaded', () => {
            Array.from(document.querySelectorAll('[data-glide]')).forEach((el) => {
                try {
                    const slides = Array.from(el.querySelectorAll('.glide__slide'));
                    const settings = this.getTypeSettings(el.dataset.glideType, slides.length);
                    const slider = new Glide(el, settings);
                    let indexMovingOut;
                    let indexMovingIn;

                    if (slides.length > 0) {
                        slider.on('run.before', (move) => {
                            indexMovingOut = slider.index;
                        }).on('run', (move) => {
                            indexMovingIn = slider.index;
                            slides[indexMovingOut].classList.add('out');
                            slides[indexMovingIn].classList.add('in');
                        }).on('run.after', (move) => {
                            slides[indexMovingOut].classList.remove('out');
                            slides[indexMovingIn].classList.remove('in');
                        });
    
                        slider.mount();
                    }
                } catch (e) {
                    console.error('Error', e);
                }
            });
        });
    }

    getTypeSettings(type, numberOfSlides) {
        let countPerView = numberOfSlides < 3 ? 1 : 3;
        const settings = {
            'testimonials': {
                type: 'carousel',
                perView: countPerView,
                focusAt: 'center',
                autoplay: false,
                animationDuration: 600,
                breakpoints: {
                    1440: { perView: 2 },
                    992: { perView: 1 },
                },
            },
            'related-items': {
                type: 'carousel',
                perView: countPerView,
                autoplay: false,
                animationDuration: 400,
                breakpoints: {
                    1200: { perView: 3 },
                    1024: { perView: 2 },
                    768: { perView: 1 },
                },
            },
        };
        return settings[type];
    }
}

new glideLoader();
